export const pagesAttendanceEngineEn = {
  atomDetail: {
    applyDialog: {
      cancel: 'Cancel',
      confirm: 'Apply',
      description: 'Moves the record from draft to applied. The mock skips process-definition selection (production follows design §4.0).',
      title: 'Apply this master?'
    },
    applyError: 'Could not apply',
    applySuccess: 'Applied',
    deleteDialog: {
      blockedByUsage: 'In use by a work structure and cannot be deleted.',
      cancel: 'Cancel',
      confirm: 'Delete',
      description: 'This cannot be undone. Remove it from work structure composition first if it is in use.',
      title: 'Delete this master?'
    },
    deleteError: 'Could not delete',
    deleteSuccess: 'Deleted',
    documentTitleFallback: 'Master detail',
    documentTitleSuffix: 'Attendance Engine',
    editDialog: {
      cancel: 'Cancel',
      save: 'Save',
      title: 'Edit master',
      unitResetHint: 'Changing the value type clears the current unit of measurement ({{unit}}).'
    },
    errors: {
      invalidConfigJson: 'Must be valid JSON'
    },
    fields: {
      category: 'Category',
      code: 'Code',
      countryCode: 'Country code',
      createdAt: 'Created at',
      createdBy: 'Created by',
      dataType: 'Data type',
      description: 'Description',
      isDefault: 'Legal default',
      lifecycleStatus: 'Status',
      managementTags: 'Management tags',
      name: 'Name',
      nameEn: 'English name',
      no: 'No.',
      referenceColumn: 'Reference column',
      referenceTable: 'Reference table',
      unitOfMeasurement: 'Unit of measurement',
      updatedAt: 'Updated at',
      validFrom: 'Valid from',
      validPeriod: 'Valid period',
      validTo: 'Valid to (leave empty for open-ended)',
      valueType: 'Value type'
    },
    header: {
      apply: 'Apply',
      delete: 'Delete',
      edit: 'Edit',
      moreActions: 'More actions',
      retire: 'Archive'
    },
    lifecycle: {
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft'
    },
    lookupTable: {
      editInReferenceCatalog: 'Edit in attendance reference catalog',
      editInStatutoryStandards: 'Edit in statutory standards',
      empty: {
        inquiryDescription: 'The table behind this item is supplied by statutory standards, or by the attendance reference catalog when the customer defines it. No catalog entry points at this item yet.',
        referenceDescription: 'The table behind this item is supplied by the attendance reference catalog. No catalog entry points at this item yet.',
        title: 'No lookup table.'
      }
    },
    retireDialog: {
      cancel: 'Cancel',
      confirm: 'Archive',
      description: 'Moves the record from applied to archived. Check downstream work structures if still referencing it.',
      title: 'Archive this master?'
    },
    retireError: 'Could not archive',
    retireSuccess: 'Archived',
    saveError: 'Could not save',
    saveSuccess: 'Saved',
    sections: {
      audit: 'Audit',
      basic: 'Basic information',
      identity: 'Identity',
      inquiry: 'Inquiry',
      itemDefinition: 'Item Definition',
      logic: 'Logic',
      peopleCondition: 'People condition (People Group)',
      peopleConditionHint: 'Optional peopleGroupIds live in config JSON. Edit them in the rule body above.',
      reference: 'Reference',
      ruleBody: 'Rule body (config)',
      ruleBodyHint: 'Stored as JSON. Omit peopleGroupIds or use an empty array when this component has no People Group scope (design §5.6).',
      status: 'Status',
      usage: 'Where used'
    },
    usage: {
      attendanceStructures: 'Work structures',
      columns: {
        name: 'Name',
        type: 'Type'
      },
      empty: 'Not referenced by any work structure.'
    },
    view: {
      openEndedValidTo: '— (open-ended)',
      referenceTable: '{{name}} ({{code}})',
      validPeriod: {
        openEnded: '{{start}} –',
        range: '{{start}} – {{end}}'
      }
    }
  },
  atomList: {
    addRecordLabels: {
      attendance_item: 'Add attendance item',
      attendance_logic_component: 'Add attendance logic component',
      attendance_unit: 'Add attendance unit',
      pay_structure: 'Add attendance structure',
      pay_unit: 'Add attendance unit',
      payroll_item: 'Add attendance item',
      work_structure: 'Add work structure'
    },
    addRecordMenu: {
      bulk: 'Add in bulk',
      fromLibrary: 'Add from library',
      manually: 'Add manually'
    },
    bulkAddDialog: {
      download: 'Download',
      dropZoneTitle: 'Click here or drag file to upload',
      invalidFileType: 'This file type cannot be imported.',
      parseFailed: 'The file could not be read.'
    },
    bulkAddYamlErrors: {
      conflictingRoots: 'The file contains both "{{listKey}}:" and "{{singleKey}}:". Keep only one of them.',
      duplicateExistingName: 'The name "{{value}}" is already registered. Remove it from the file, or change the name.',
      duplicateKey: 'Line {{line}}: the key "{{key}}" appears more than once.',
      duplicateName: 'Line {{line}}: the name "{{value}}" appears more than once in the file.',
      emptyFile: 'The file is empty.',
      indent: 'Line {{line}}: the indentation does not line up. Use two spaces per level, and do not use tabs.',
      invalidRecord: 'Line {{line}}: this entry could not be read as a record. Each entry needs a "name" line.',
      missingName: 'Line {{line}}: "name" is required.',
      missingRoot: 'The file does not start with "{{root}}:".',
      noRecords: 'The file has no entries under "{{root}}:".',
      syntax: 'Line {{line}}: this line could not be read. Write it as "key: value".',
      unsupported: 'Line {{line}}: this YAML notation is not supported. Write values as plain text or in single quotes.',
      unsupportedField: 'Line {{line}}: "{{field}}" cannot be imported on this screen. Remove it from the file.'
    },
    columns: {
      category: 'Category',
      country: 'Country',
      description: 'Description',
      name: 'Name',
      type: 'Type',
      validFrom: 'Valid From'
    },
    createRecordToastDescription: 'Creating records from this list will be available when the create flow is implemented.',
    createRecordToastTitle: 'Not available yet',
    filters: {
      allCountries: 'All Countries',
      countryChip: 'Country',
      global: 'Global',
      jp: 'Japan',
      sg: 'Singapore'
    },
    lifecycleTabs: {
      all: 'All',
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft',
      scheduled: 'Scheduled'
    }
  },
  attendanceStructures: {
    componentCount: '{{count}} components',
    custom: 'Custom',
    default: 'Default',
    noAttendanceStructures: 'No work structures registered',
    noPayrollStructures: 'No pay structures registered',
    title: 'Work Structures'
  },
  attendanceStructuresList: {
    addManually: {
      toastError: 'Failed to add an attendance structure.'
    },
    bulkAdd: {
      acceptLabel: 'yaml file',
      confirmDescription: '{{total}} attendance structures will be added as drafts. Only the name, English name and description of each entry are imported. Review the list below before importing.',
      description: 'Upload a YAML file to add multiple attendance structures at once. Only the name, English name and description of each entry are imported, and imported structures are created as drafts.',
      submit: 'Add in bulk',
      templateFileName: 'Template.yaml',
      templateLabel: 'YAML template',
      title: 'Add attendance structure in bulk',
      toastError: 'Failed to add attendance structures.',
      toastSuccess: 'Added {{total}} attendance structures.'
    },
    columns: {
      componentCount: 'Components',
      country: 'Country',
      description: 'Description',
      name: 'Name',
      nameEn: 'English name',
      type: 'Type',
      updatedAt: 'Updated'
    }
  },
  attendanceUnitsList: {
    addManually: {
      toastError: 'Failed to add an attendance unit.'
    },
    bulkAdd: {
      acceptLabel: 'yaml file',
      confirmDescription: '{{total}} attendance units will be added as drafts. Only the code, name and description of each entry are imported. Review the list below before importing.',
      description: 'Upload a YAML file to add multiple attendance units at once. Only the code, name and description of each entry are imported, and imported units are created as drafts.',
      submit: 'Add in bulk',
      templateFileName: 'Template.yaml',
      templateLabel: 'YAML template',
      title: 'Add attendance unit in bulk',
      toastError: 'Failed to add attendance units.',
      toastSuccess: 'Added {{total}} attendance units.'
    },
    columns: {
      code: 'Code',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name'
    },
    empty: 'No attendance units yet.',
    export: 'Export',
    filters: {
      managementTag: 'Attendance item management tags',
      managementTagPlaceholder: 'Search management tags...'
    },
    searchPlaceholder: 'Filter by name...'
  },
  categories: {
    dailyAggregates: 'Daily Aggregates',
    inquiry: 'Inquiry',
    monthlyAggregates: 'Monthly Aggregates',
    periodAggregates: 'Settlement Period Aggregates',
    references: 'References',
    weeklyAggregates: 'Weekly Aggregates'
  },
  components: {
    categories: {
      calculation_logic: 'Calculation Logic',
      deduction_item: 'Deduction Item',
      earning_item: 'Earning Item',
      payment_cycle: 'Payment Cycle',
      proration_method: 'Proration Method',
      rounding_rule: 'Rounding Rule',
      social_insurance: 'Social Insurance'
    },
    columns: {
      category: 'Category',
      country: 'Country',
      description: 'Description',
      name: 'Name',
      type: 'Type',
      validFrom: 'Valid From'
    },
    filters: {
      allCategories: 'All Categories',
      allCountries: 'All Countries'
    },
    title: 'Components',
    types: {
      custom: 'Custom',
      default: 'Legal Default'
    }
  },
  durationUnits: {
    day: 'day',
    hour: 'hour',
    minute: 'minute',
    second: 'second'
  },
  itemDetail: {
    payrollUnits: {
      columns: {
        code: 'Code',
        description: 'Description',
        name: 'Attendance unit',
        payrollStructures: 'Attendance structures'
      },
      empty: 'No attendance unit uses this attendance item.',
      noStructures: '—'
    },
    reports: {
      aggregateFields: {
        collectedTax: 'Collected tax amount',
        paidAmount: 'Payment amount',
        remuneration: 'Monthly remuneration',
        socialInsurance: 'Social insurance premiums',
        totalWages: 'Total wages',
        withheldTax: 'Withheld tax amount'
      },
      columns: {
        itemName: 'Item name on the report',
        report: 'Report'
      },
      empty: 'This item is not output to any Salary & Wages report. Input, master and intermediate items are not reported directly.',
      emptyOutOfCountryScope: 'The reports listed here are Japanese statutory reports, so this item is out of scope.'
    },
    tabs: {
      detail: 'Detail',
      payrollUnits: 'Attendance units',
      reports: 'Reports'
    }
  },
  itemsAdd: {
    cards: {
      category: 'Category',
      code: 'Code',
      description: 'Description',
      inquiryCatalogEntry: 'Inquiry source',
      lifecycleStatus: 'Status',
      managementTags: 'Management tags',
      name: 'Name',
      unitOfMeasurement: 'Unit of measurement',
      validPeriod: 'Valid period',
      valueType: 'Value type'
    },
    errors: {
      duplicateExistingCode: 'This code is already used by another attendance item.'
    },
    fields: {
      currencyCode: 'Currency code',
      denominatorUnit: 'Per time unit',
      denominatorValue: 'Per quantity',
      durationUnit: 'Time unit',
      unit: 'Unit',
      validFrom: 'Valid from',
      validTo: 'Valid to (leave empty for open-ended)'
    },
    hints: {
      denominator: 'Leave the quantity empty for a plain amount. Fill it in for a rate such as JPY / hour.',
      inquiryCatalogEntry: 'Inquiry items read their value from a table in the attendance inquiry catalog. Pick the source table.',
      noManagementTags: 'No management tag has been used yet.'
    },
    lifecycleStatuses: {
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft'
    },
    placeholders: {
      select: 'Select...',
      text: 'ex) xxx…'
    },
    steps: {
      identity: 'Identity',
      itemDefinition: 'Item Definition',
      status: 'Status'
    },
    title: 'Add attendance item',
    toastError: 'Failed to add the attendance item.',
    toastSuccess: 'Added the attendance item "{{name}}".'
  },
  itemsList: {
    bulkAdd: {
      acceptLabel: 'csv file',
      confirmDescription: '{{total}} attendance items will be added as drafts. Review the list below before importing.',
      description: 'Upload a CSV file to add multiple attendance items at once. Imported items are created as drafts.',
      errors: {
        duplicateCode: 'Line {{line}}: the code "{{value}}" appears more than once in the file.',
        duplicateColumns: 'These columns appear more than once in the header: {{columns}}.',
        duplicateExistingCode: 'The code "{{value}}" is already registered. Remove it from the file, or change the code.',
        emptyFile: 'The file is empty.',
        invalidCategory: 'Line {{line}}: "{{value}}" is not a valid category. Use earnings, deductions, aggregates, adjustments, employerContributions, reimbursements, paymentsInKind, references or inquiry.',
        invalidValueType: 'Line {{line}}: "{{value}}" is not a valid value type. Use quantity, coefficient, money, table, enumeration, date, time or duration.',
        missingColumns: 'These columns are missing: {{columns}}.',
        missingValue: 'Line {{line}}: "{{column}}" is required.',
        noRows: 'The file has no data rows.'
      },
      submit: 'Add in bulk',
      templateFileName: 'attendance-item-template.csv',
      templateLabel: 'CSV template',
      title: 'Add attendance item in bulk',
      toastError: 'Failed to add attendance items.',
      toastSuccess: 'Added {{total}} attendance items.'
    },
    categorySidebar: {
      close: 'Close categories',
      open: 'Open categories',
      title: 'Bookkeeping category'
    },
    columns: {
      badge: 'Badge',
      code: 'Code',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
      no: 'No.',
      status: 'Status',
      tags: 'Tags'
    },
    empty: 'No attendance items yet.',
    export: 'Export',
    filters: {
      managementTag: 'Management tag',
      managementTagPlaceholder: 'Search management tags...'
    },
    searchPlaceholder: 'Filter by name...'
  },
  logicComponentDetail: {
    payrollUnits: {
      columns: {
        code: 'Code',
        description: 'Description',
        name: 'Attendance unit',
        payrollStructures: 'Attendance structures'
      },
      empty: 'No attendance unit uses this logic component.',
      noStructures: '—'
    },
    tabs: {
      detail: 'Detail',
      payrollUnits: 'Attendance units'
    }
  },
  logicComponentsList: {
    columns: {
      badge: 'Badge',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
      returnItem: 'Return Item'
    },
    empty: 'No attendance logic components yet.'
  },
  pageTitle: 'Attendance Engine',
  structureDetail: {
    actions: {
      cancel: 'Cancel',
      compositionNotSavedDescription: 'Saving a draft only stores the name and description. The composition you edited stays on screen but is lost when you leave this page.',
      compositionNotSavedTitle: 'The composition was not saved.',
      saveAsDraft: 'Save as draft',
      saveAsDraftError: 'Could not save the draft.'
    },
    composition: {
      empty: 'No engine components are linked.',
      kind: {
        item: 'Item',
        logic_component: 'Logic Component'
      },
      missingRow: 'Component record not found.',
      openAtom: 'Open master detail',
      sameAsPaymentCycleNote: '',
      sectionTitle: 'Components in this structure'
    },
    deleteDialog: {
      cancel: 'Cancel',
      confirm: 'Delete',
      description: 'This cannot be undone. Remove references from workforce assignments first if needed.',
      title: 'Delete this work structure?'
    },
    descriptionPlaceholder: 'description',
    discardDialog: {
      cancel: 'Keep editing',
      confirm: 'Discard and leave',
      description: 'The composition you edited has not been saved. Leaving this page discards it.',
      title: 'Discard unsaved changes?'
    },
    documentTitleFallback: 'Structure detail',
    documentTitleSuffix: 'Attendance Engine',
    dynamics: {
      emptyComposition: 'No composition steps are linked. The payment cycle node is shown when assigned.'
    },
    dynamicsV2: {
      simulationToolbar: {
        removePerson: 'Remove',
        runSimulation: 'Run simulation',
        selectPersonLabel: 'Simulation subject',
        selectPersonPlaceholder: 'Select a person',
        simulationToastDescription: '{{count}} person(s) included (preview only).',
        simulationToastNoPeople: 'Select at least one person before running the simulation.',
        simulationToastTitle: 'Simulation finished'
      },
      stagePill: 'Stage {{index}}'
    },
    editDialog: {
      cancel: 'Cancel',
      fields: {
        countryCode: 'Country code',
        description: 'Description',
        isDefault: 'Legal default',
        name: 'Name',
        nameEn: 'English name'
      },
      save: 'Save',
      saveError: 'Could not save',
      saveSuccess: 'Saved',
      title: 'Edit work structure'
    },
    fields: {
      countryCode: 'Country code',
      createdAt: 'Created at',
      createdBy: 'Created by',
      description: 'Description',
      isDefault: 'Legal default',
      lifecycleStatus: 'Status',
      name: 'Name',
      nameEn: 'English name',
      updatedAt: 'Updated at'
    },
    mock: {
      card: {
        detail: 'Detail'
      },
      edit: {
        addStage: 'Add stage',
        addSubstage: 'Add sub stage',
        addUnit: 'Add attendance unit',
        empty: 'No options left.',
        noMatch: 'No matching options.',
        reorder: {
          announceGrabbed: 'Grabbed {{name}}. Use the arrow keys to move it, Enter to drop, Escape to cancel.',
          announceMoved: 'Moved {{name}} to position {{position}}',
          grabAriaLabel: 'Reorder {{name}}',
          hint: 'Grab a handle and use the arrow keys to reorder.',
          roleDescription: 'sortable item'
        },
        searchStagePlaceholder: 'Search stage...',
        searchUnitPlaceholder: 'Search attendance unit...'
      },
      empty: 'No attendance unit is selected.',
      loadError: 'Failed to load the attendance unit.',
      loading: 'Loading…',
      matrix: {
        collapseRow: 'Collapse',
        empty: 'This structure has no attendance unit yet.',
        expandRow: 'Expand',
        input: 'Input',
        items: 'Items',
        output: 'Output',
        rowHeader: 'Stage > Sub stage > Unit'
      },
      openUnitDetail: 'Open unit detail page',
      section: {
        input: 'INPUT',
        output: 'OUTPUT',
        process: 'PROCESS'
      },
      sidebar: {
        allStages: 'All stages',
        close: 'Close side tab',
        collapseGroup: 'Collapse group',
        expandGroup: 'Expand group',
        stages: {
          complianceAndClose: 'Compliance Checks & Closing',
          dailyClassification: 'Daily Time Classification',
          intake: 'Data Intake',
          monthlyAggregation: 'Monthly Aggregation',
          weekAndPeriod: 'Week & Settlement Period',
          workTimeFix: 'Work Time Determination',
          workingHours: 'Working Hours'
        }
      },
      stage: {
        branchBadge: 'Branch',
        descriptions: {
          complianceAndClose: 'Check the overtime agreement, weekly limits and break entitlement, then decide whether the month can be closed.',
          dailyClassification: 'Split the daily working hours into statutory overtime, overtime within statutory hours, scheduled hours, late night and holiday work.',
          intake: 'Take punches, the work calendar and scheduled working hours into the attendance calculation.',
          monthlyAggregation: 'Aggregate daily, weekly and settlement period values into the month and fix the items handed to the payroll engine.',
          weekAndPeriod: 'Determine the overtime that daily figures cannot reveal, using the weekly statutory cap and the flex settlement period.',
          workTimeFix: 'Apply the rounding rules to fix the start and end date-times.',
          workingHours: 'Derive working hours, time on premises, break taken and scheduled working hours from the worked segments.'
        },
        empty: 'No attendance unit belongs to this stage.',
        input: 'Input',
        openUnit: 'Show detail of {{name}}',
        output: 'Output:',
        stageBadge: 'Stage',
        substageBadge: 'Substage',
        unitBadge: 'Unit'
      },
      substage: {
        filterRule: 'Assignment rule',
        inputItem: 'INPUT ITEM',
        output: 'Output:',
        unitBadge: 'Unit',
        value: 'VALUE'
      },
      toolbar: {
        completed: 'Completed',
        dryRun: 'DRY RUN',
        run: 'Run',
        viewList: 'List',
        viewMatrix: 'Matrix',
        viewNode: 'Node',
        viewYaml: 'YAML'
      },
      yaml: {
        copy: 'Copy',
        download: 'Download',
        edit: 'Edit',
        empty: 'This structure has no attendance unit yet.'
      }
    },
    namePlaceholder: 'Name',
    paymentCycle: {
      cardTitle: 'Assigned payment cycle',
      missing: 'Payment cycle master was not found.'
    },
    sections: {
      audit: 'Audit',
      basic: 'Basic information',
      composition: 'Composition',
      paymentCycle: 'Payment cycle'
    },
    structure: {
      badges: {
        deduction: 'Deduction',
        earning: 'Earning',
        total: 'Total'
      },
      demoCaption: 'Illustrative process flow (design reference). Live composition mapping will replace this preview when the engine exposes process units.',
      demoFootnote: 'Unit labels are English examples only; they are not read from your structure data yet.',
      logicKinds: {
        arithmetic: 'Arithmetic',
        multiply: 'Multiply',
        subtract: 'Subtract',
        sum: 'Sum',
        tableLookup: 'Table Lookup'
      },
      segmentInput: 'Input',
      segmentLogic: 'Logic',
      segmentOutput: 'Output',
      steps: {
        baseSalary: {
          formula: 'f(grade, job type) → base salary table → base salary amount',
          inputs: {
            grade: 'Grade',
            jobType: 'Job type',
            table: 'Base salary table'
          },
          link: 'Base salary',
          output: 'Base salary',
          title: 'Base salary'
        },
        commuting: {
          inputs: {
            route: 'Commute route',
            table: 'Commuting allowance table'
          },
          link: 'Non-taxable commuting allowance',
          output: 'Non-taxable commuting allowance',
          title: 'Non-taxable commuting allowance'
        },
        healthInsurance: {
          inputs: {
            gross: 'Gross pay (basis)',
            premiumTable: 'Premium table'
          },
          link: 'Health / nursing premiums',
          output: 'Health / nursing premiums',
          title: 'Health insurance / nursing care insurance'
        },
        overtimePay: {
          formula: 'Overtime rate × overtime hours × premium rate',
          inputs: {
            hours: 'Overtime hours',
            premium: 'Premium rate',
            rate: 'Overtime rate'
          },
          link: 'Overtime allowance',
          output: 'Overtime allowance',
          title: 'Overtime allowance'
        },
        overtimeUnit: {
          inputs: {
            grade: 'Grade',
            rateTable: 'Overtime rate table'
          },
          link: 'Overtime unit price',
          output: 'Overtime unit price',
          title: 'Overtime unit price'
        },
        paidBaseSalary: {
          formula: 'Base salary − (base salary ÷ prescribed hours × absence hours)',
          inputs: {
            absence: 'Absence hours',
            base: 'Base salary',
            baseAgain: 'Base salary (again)',
            prescribedHours: 'Prescribed hours / month'
          },
          link: 'Paid base salary',
          output: 'Paid base salary',
          title: 'Paid base salary'
        },
        positionAllowance: {
          inputs: {
            amountTable: 'Position amount table',
            role: 'Role'
          },
          link: 'Position allowance',
          output: 'Position allowance',
          title: 'Position allowance'
        },
        totalEarnings: {
          inputs: {
            items: 'All earning items'
          },
          link: 'Gross pay',
          output: 'Gross pay',
          title: 'Total earnings'
        }
      }
    },
    tabs: {
      detail: 'Overview',
      dynamics: 'Dynamics',
      dynamicsV2: 'Dynamics v2',
      structure: 'Structure'
    }
  },
  tabs: {
    attendanceStructures: 'Attendance Structures',
    attendanceUnits: 'Attendance Units',
    items: 'Attendance Items',
    logicComponents: 'Logic Components'
  },
  unitDetail: {
    actions: {
      cancel: 'Cancel',
      compositionNotSavedDescription: 'Saving a draft only stores the name and description. The composition you edited stays on screen but is lost when you leave this page.',
      compositionNotSavedTitle: 'The composition was not saved.',
      edit: 'Edit',
      saveAsDraft: 'Save as draft',
      saveAsDraftError: 'Could not save the draft.'
    },
    addLogicComponent: 'Add logic component',
    columns: {
      argument: 'ARGUMENT',
      item: 'ITEM',
      value: 'VALUE'
    },
    descriptionPlaceholder: 'description',
    discardDialog: {
      cancel: 'Keep editing',
      confirm: 'Discard and leave',
      description: 'The composition you edited has not been saved. Leaving this page discards it.',
      title: 'Discard unsaved changes?'
    },
    dryRun: {
      completed: 'Completed',
      label: 'DRY RUN',
      run: 'Run'
    },
    history: {
      attributes: {
        argumentItem: 'Argument item',
        description: 'Description',
        logicComponent: 'Logic component',
        name: 'Name',
        step: 'Step'
      },
      eventTypes: {
        unitCreated: 'Unit created',
        unitUpdated: 'Unit updated'
      },
      openEvent: 'Open the business event',
      sources: {
        manualEdit: 'Manual edit'
      },
      usage: {
        event: 'Business event',
        result: 'Result',
        results: {
          completed: 'Completed',
          inProgress: 'In progress'
        },
        structure: 'Attendance structure',
        targetEmployees: 'Target employees'
      }
    },
    logicComponent: 'Logic Component',
    namePlaceholder: 'Name',
    output: 'Output:',
    return: 'RETURN',
    select: {
      inUnitVariables: 'In-unit variables',
      items: 'Items',
      predefinedValues: 'Predefined items? values for logic',
      searchPlaceholder: 'Search option...'
    },
    tabs: {
      detail: 'Detail',
      history: 'History'
    },
    view: {
      list: 'List',
      node: 'Node',
      yaml: 'YAML'
    },
    yaml: {
      copy: 'Copy',
      download: 'Download',
      edit: 'Edit',
      empty: 'This attendance unit has no logic component yet.'
    }
  },
  valueTypes: {
    address: 'Address',
    coefficient: 'Coefficient',
    date: 'Date',
    duration: 'Duration',
    enumeration: 'Enumeration',
    money: 'Money',
    quantity: 'Quantity',
    table: 'Table',
    time: 'Time'
  }
};